import { render, staticRenderFns } from "./SdsTableSection9.vue?vue&type=template&id=2c9096c4&scoped=true"
import script from "./SdsTableSection9.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsTableSection9.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SdsTableSection9.vue?vue&type=style&index=0&id=2c9096c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9096c4",
  null
  
)

export default component.exports